import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Icone } from './Icone';

/**
 * Champ action (charte, doc 06). Remplace le lien souligné pour tout ce qui
 * ouvre une fiche ou une pièce : le soulignement disparaît, une icône fine
 * porte l'affordance.
 *
 * La couleur reste le Majorelle au repos — la charte réserve cette teinte au
 * lien, et retirer à la fois le trait et la couleur rendrait la cible
 * indevinable. Seule l'intensité change au survol, où le chevron avance d'un
 * cheveu.
 */

/** Référence ouvrant une fiche : le chevron suit le texte. */
export function LienFiche({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Link className="lien-action" to={to}>
      <span>{children}</span>
      <Icone nom="ouvrir" taille={14} classe="lien-action__chevron" />
    </Link>
  );
}

/** Pièce déposée : l'icône précède le nom du fichier, qui reste lisible seul. */
export function LienPiece({ href, children }: { href: string; children: ReactNode }) {
  return (
    <a className="lien-action" href={href} target="_blank" rel="noreferrer">
      <Icone nom="piece" taille={14} />
      <span>{children}</span>
    </a>
  );
}
